import { useEffect } from "react";
import Logo from "@/components/Logo";
import Hero from "@/optionb/Hero";
import { Marquee, Specialties, Philosophy } from "@/optionb/Sections";
import Programs from "@/optionb/Programs";
import { About, Faq, Contact } from "@/optionb/Closing";
import { EMAIL } from "@/lib/content";

const FOOTER_LINKS = [
  { href: "#specialties", label: "What I help with", tid: "footer-link-specialties" },
  { href: "#programs", label: "Programs", tid: "footer-link-programs" },
  { href: "#about", label: "About", tid: "footer-link-about" },
  { href: "#faq", label: "FAQ", tid: "footer-link-faq" },
  { href: "#contact", label: "Contact", tid: "footer-link-contact" },
];

function Footer() {
  return (
    <footer className="bg-forest text-cream overflow-hidden">
      <div className="max-w-[1360px] mx-auto px-6 lg:px-12 pt-16 pb-8">
        <p
          aria-hidden="true"
          className="font-displayb font-light italic text-[clamp(3rem,10vw,9rem)] leading-none text-cream/10 select-none"
        >
          Well&Truly
        </p>
        <p aria-hidden="true" className="mt-3 font-displayb italic text-cream/40 text-lg">
          by Akanksha
        </p>
        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
          <Logo variant="b" onDark />
          <nav className="flex flex-wrap gap-x-7 gap-y-3 text-sm text-cream/60">
            {FOOTER_LINKS.map((l) => (
              <a key={l.href} href={l.href} data-testid={l.tid} className="hover:text-clay transition-colors">
                {l.label}
              </a>
            ))}
          </nav>
          <div className="sm:text-right text-sm">
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email"
              className="text-cream hover:text-clay transition-colors"
            >
              {EMAIL}
            </a>
            <p className="mt-1 text-cream/50">Dubai, United Arab Emirates</p>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-cream/15 flex flex-col sm:flex-row justify-between gap-2 text-xs text-cream/40">
          <span data-testid="footer-copyright">
            © {new Date().getFullYear()} Well&Truly by Akanksha. All rights reserved.
          </span>
          <span>wellandtruly.fit</span>
        </div>
      </div>
    </footer>
  );
}

export default function OptionB() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, follow";
    document.head.appendChild(meta);
    const prev = document.title;
    document.title = "Well&Truly — Option B · Editorial mockup";
    return () => {
      document.head.removeChild(meta);
      document.title = prev;
    };
  }, []);

  return (
    <div className="grain bg-cream font-bodyb text-forest" data-testid="page-option-b">
      <Hero />
      <Marquee />
      <Specialties />
      <Philosophy />
      <Programs />
      <About />
      <Faq />
      <Contact />
      <Footer />
    </div>
  );
}
